'use client'

import { Tooltip } from '@graftcode/design-system'

import { ALPHA_LABEL_TEST_IDS } from '@common/common-test-ids.const'
import { getDocsExternalUrl } from '@common/utils/getDocsExternalUrl'

import type { Props } from './AlphaLabel.types'

import styles from './AlphaLabel.module.scss'

const DOCS_KNOWN_LIMITATIONS_URL = `${getDocsExternalUrl() || 'https://docs.graftcode.com'}/reference/known-limitations`

const tooltipContent = (
  <div className={styles.tooltipContent}>
    <span>Graftcode is currently in early </span>
    <span>development. Some features may </span>
    <span>
      change or be unstable.{' '}
      <a className={styles.learnMoreLink} href={DOCS_KNOWN_LIMITATIONS_URL} target="_blank" rel="noopener noreferrer">
        LEARN MORE
      </a>
    </span>
  </div>
)

export function AlphaLabel({ withTooltip = true }: Props) {
  if (!withTooltip) {
    return (
      <span className={styles.label} data-testid={ALPHA_LABEL_TEST_IDS.root}>
        ALPHA
      </span>
    )
  }

  return (
    <Tooltip content={tooltipContent} placement="bottom" showArrow>
      <div data-testid={ALPHA_LABEL_TEST_IDS.root}>
        <span className={styles.label}>ALPHA</span>
      </div>
    </Tooltip>
  )
}
